import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { ILogin } from "../../../models/Login";
import { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../../shared/Fetch";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { TenderClientDetails } from "./Tender_Client_Details";
import { ITenderClientPOC } from "./Tender_Client_POC";
import { Filter, IFilter } from "./Filter";
import { Accordion, AccordionTab } from "primereact/accordion";

interface IProps {
  setModal: (modal: any) => void;
  reload: boolean;
  toast: any;
}

export const EmptyFilter: IFilter = {
  // fromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  // toDate: new Date(),
  fromDate: null,
  toDate: new Date(),
  vendor_Company: null,
  vendor_Company_Name: null,
  contact_Person_Name: "",
  contact_Person_EmailID: "",
  department: null,
  designationId: null,
  added_By: null,
};

export const Table = (props: IProps) => {
  const [tableData, setTableData] = useState<{ tableData: ITenderClientPOC[]; loading: boolean }>({ tableData: [], loading: false });
  const [openClientDetailsD, setOpenClientDetailsD] = useState({ singleData: {}, open: false } as { singleData: ITenderClientPOC; open: boolean });
  const [filters, setFilters] = useState<IFilter>(EmptyFilter);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyParams, setLazyParams] = useState<ILazyParams>({ first: 0, rows: 25, page: 1, sortField: "Added_On", sortOrder: -1 });
  const dt = useRef<any>(null);
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;

  const getTableDataCount = async () => {
    const response = await Fetch("Tender_POC_Mast/count", "GET", null, `filter=${JSON.stringify(filters)}`, props.toast);
    if (response) {
      const count: number = parseInt(await response.text(), 10);
      setTotalRecords(count);
    }
  };

  const loadTenderclient = async () => {
    try {
      setTableData((prev: any) => ({ ...prev, loading: true }));

      let newFilter: any = filters;

      if (newFilter.vendor_Company && newFilter.vendor_Company?.vendor_Company_ID !== undefined && newFilter.vendor_Company?.vendor_Company_ID > 0) {
        newFilter.vendor_Company_Name = newFilter.vendor_Company.vendor_Company_Name;
      }

      if (newFilter.vendor_Company?.vendor_Company_ID !== undefined && newFilter.vendor_Company?.vendor_Company_ID !== null) {
        delete newFilter.vendor_Company;
      }

      const response = await Fetch("Tender_POC_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(newFilter)}`, props.toast);

      if (response?.ok) {
        const data = await response.json();
        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    loadTenderclient();
    getTableDataCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reload, filters, lazyParams]);

  const leftToolbarTemplate = () => {
    return (
      <>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </>
    );
  };
  const openNew = () => {
    props.setModal({ singleData: {}, open: true });
  };

  const openClientDetails = (data: ITenderClientPOC) => {
    setOpenClientDetailsD({ singleData: data, open: true });
  };

  const openEdit = (rowDatauser: ITenderClientPOC) => {
    props.setModal({ open: true, singleData: rowDatauser });
  };

  const actionBodyTemplate = (rowData: ITenderClientPOC) => {
    return (
      <div className="actions">
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
      </div>
    );
  };

  const onPage = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
  };
  const onSort = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
  };

  return (
    <>
      <Toolbar left={leftToolbarTemplate} className="mb-3" />
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filters={filters} setFilters={(filters: IFilter) => setFilters(filters)} loading={tableData.loading} />
        </AccordionTab>
      </Accordion>
      <DataTable
        value={tableData.tableData}
        loading={tableData.loading}
        showGridlines
        stripedRows
        header="RFP Client"
        paginator
        ref={dt}
        first={lazyParams.first}
        rows={lazyParams.rows}
        rowsPerPageOptions={[25, 50, 100, 200]}
        totalRecords={totalRecords}
        onPage={onPage}
        onSort={onSort}
        lazy
        sortField={lazyParams.sortField}
        sortOrder={lazyParams.sortOrder}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        emptyMessage="No POC found."
      >
        <Column header="SN." body={(data, options) => options.rowIndex + 1} />
        <Column
          field="tender_Client_Name"
          header="Client Name"
          body={(rowData: ITenderClientPOC) => (
            <p className="cursor-pointer text-cyan-700 underline" onClick={() => openClientDetails(rowData)}>
              {rowData.tender_Client_Name}
            </p>
          )}
        />
        <Column field="department" header="Department" />
        <Column field="designation_Name" header="Designation" />
        <Column field="contact_Name" header="Contact Name" />
        <Column field="contact_Email" header="Contact Email" />
        <Column field="contact_Phone" header="Contact Phone" />
        <Column field="contact_Mobile" header="Contact Mobile" />
        <Column field="major_Technology" header="Major Technology" />
        <Column field="added_By" header="Added By" />
        <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} sortable />
        <Column field="updated_By" header="Updated By" />
        <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} sortable />
        <Column header="Actions" body={actionBodyTemplate} />
      </DataTable>
      <TenderClientDetails singleData={openClientDetailsD.singleData} open={openClientDetailsD.open} hideDialog={() => setOpenClientDetailsD({ singleData: {}, open: false })} toast={props.toast} />
    </>
  );
};
